import { Component, OnInit } from '@angular/core';
import { take, catchError } from 'rxjs/operators';
import { Warehouse } from '../../models/warehouse.model';
import { WarehouseLocation } from '../../models/warehouse-location.model';
import { WarehouseService } from '../../services/warehouse.service';
import { WarehouseLocationService } from '../../services/warehouse-location.service';

@Component({
    selector: 'app-locations-labels',
    templateUrl: './locations-labels.component.html',
    styleUrls: ['./locations-labels.component.scss'],
    standalone: false
})
export class LocationsLabelsComponent implements OnInit {

  warehouses: Warehouse[] = [];
  selectedWarehouseId: number = -1;

  warehouseLocations: WarehouseLocation[] = [];

  constructor(private warehouseService: WarehouseService,
    private warehouseLocationService: WarehouseLocationService) { }

  ngOnInit(): void {
    this.loadWarehouses();
  }

  loadWarehouses() {
    this.warehouseService.getAllWarehouses()
    .pipe(take(1))
    .pipe(catchError((e) => {
      if (e.status === 403 || e.status === 401) {
        return e;
      }
      alert("Cannot load warehouses");
      return e;
    }))
    .subscribe((data: Warehouse[]) => {
      this.warehouses = data;
    })
  }

  onWarehouseChanged(warehouseId: number) {
    this.selectedWarehouseId = +warehouseId;
    this.warehouseLocations = [];

    if (this.selectedWarehouseId === -1) {
      return;
    }

    this.loadWarehouseLocations();
  }

  loadWarehouseLocations() {
    this.warehouseLocationService.getWarehouseLocationsForWarehouse(this.selectedWarehouseId)
    .pipe(take(1))
    .pipe(catchError((e) => {
      if (e.status === 403 || e.status === 401) {
        return e;
      }
      alert("Cannot load warehouse locations");
      return e;
    }))
    .subscribe((data: WarehouseLocation[]) => {
      this.warehouseLocations = data;
    })
  }

  getShelf(warehouseLocation: WarehouseLocation): string {
    return warehouseLocation.aisle + ' / ' + warehouseLocation.shelf;
  }

  getWarehouseName(warehouseLocation: WarehouseLocation): string {
    return warehouseLocation.warehouse ? warehouseLocation.warehouse.name : '';
  }

  print(): void {
    window.print();
  }
}
